// extracted by mini-css-extract-plugin
export var filterIncDec = "_52-0";
export var leftBorder = "_52-1";
export var rightBorder = "_52-2";
export var stringInput = "_52-3";